import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from "components/CustomButton";
import Loader from "components/Loader";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import WellnessService from "services/WellnessService";
import AddNewTrivia from "./AddNewTrivia";
import TriviaListItem from "./TriviaListItem";

const TRIVIA_STATUS = {
  ACTIVE: 1,
  SCHEDULED: 2,
  INACTIVE: 0,
};

export default () => {
  const params = useParams();
  const navigation = useHistory();
  const [list, setList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [activeTrivia, setActiveTrivia] = useState(0);
  const [createNewTrivia, setCreateNewTrivia] = useState(false);
  const [reload, setReload] = useState(false);
  const [haveAnyActive, setHaveAnyActive] = useState(false);

  useEffect(() => {
    setLoaded(false);
    WellnessService.getAllTriviaList(params.teamId).then((res) => {
      setList(res.data || []);
      setActiveTrivia(res.data[0]?.id || 0);
      setHaveAnyActive(
        res?.data.filter(
          (v) =>
            v.status === TRIVIA_STATUS.ACTIVE ||
            v.status === TRIVIA_STATUS.SCHEDULED
        ).length > 0
          ? true
          : false
      );
      setLoaded(true);
    });
  }, [params.teamId, reload]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center">
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{ marginRight: "15px", cursor: "pointer" }}
            onClick={() =>
              navigation.push(
                `/teams/${params.teamId}/wellness/focus-boosters/trivia`
              )
            }
          />
          <h5 style={{ margin: "0px" }}>Manage Trivia</h5>
        </div>
        <div>
          <CustomButton
            onClick={() => setCreateNewTrivia(true)}
            disabled={haveAnyActive}
          >
            Add New
          </CustomButton>
        </div>
      </div>

      {!loaded && (
        <div className="d-flex justify-content-center">
          <Loader />
        </div>
      )}

      {loaded && list.length === 0 && (
        <div className="d-flex justify-content-center">
          No trivia created yet, click on Add New to create your very first
          trivia
        </div>
      )}

      {loaded && list.length > 0 && (
        <div class="list-group">
          {list.map((item) => (
            <TriviaListItem
              data={item}
              setActiveTrivia={setActiveTrivia}
              activeTrivia={activeTrivia}
              setReload={() => setReload(!reload)}
            />
          ))}
        </div>
      )}

      {createNewTrivia && (
        <AddNewTrivia
          onClose={(flag) => {
            if (flag) {
              setReload(!reload);
            }
            setCreateNewTrivia(false);
          }}
          teamId={params.teamId}
        />
      )}
    </div>
  );
};
